import { WithBillId } from '@mews-commander/types';
import { useCorrectionDetail } from '../../../billDetail/hooks';
import { CorrectionBillLink } from '../../../companyDetail/components/Tabs/Dashboard/CorrectionBillLink';
import { BillLink } from '../../../../components';

export const OrderItemActionLogBillLink = ({ billId }: WithBillId) => {
    const { data } = useCorrectionDetail({ correctionBillId: billId });
    const { correctiveBill } = data || {};

    if (correctiveBill && correctiveBill.name) {
        return <CorrectionBillLink billId={billId} label={correctiveBill.name} />;
    }

    return <BillLink billId={billId} />;
};
